function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { context } from "../../components/wr-context";
export var proposalGenerator = function(param) {
    var id = param.id, fromDecisionTree = param.fromDecisionTree, name = param.name, companyName = param.companyName, date = param.date, status = param.status, items = param.items, options = param.options, _parentType = param.parentType, parentType = _parentType === void 0 ? "catalog" : _parentType, _parentId = param.parentId, parentId = _parentId === void 0 ? context.constants.client.catalogIds[0] : _parentId, proposalName = param.proposalName, email = param.email, value = param.value, settings = param.settings, preserveSettings = param.preserveSettings;
    var ref, ref1;
    var cartValue = value || 0;
    if (typeof value === "undefined") {
        if (fromDecisionTree) {
            Object.keys(context.state.decisionTreeCart).map(function(key) {
                cartValue += context.state.decisionTreeCart[key].price || 0;
            });
        } else {
            context.state.cart.map(function(item) {
                cartValue += (item === null || item === void 0 ? void 0 : item.price) || 0;
            });
        }
    }
    var proposal = {
        id: id,
        userId: (ref = context.state.user) === null || ref === void 0 ? void 0 : ref.id,
        companyId: context.constants.client.companyId || context.state.catalogs[0].company.id,
        parentId: parentId,
        parentType: parentType,
        status: status,
        type: "proposal",
        name: "",
        settings: {}
    };
    var catalog = context.state.catalogs.find(function(cat) {
        return cat.id === context.constants.client.catalogIds[0];
    });
    // Context- come back when it's typed
    proposal.name = proposalName || (catalog ? "".concat(name, " / ").concat(catalog.company.name) : name);
    // Context- come back when it's typed
    var storedProposal = (context.state.proposals || []).find(function(p) {
        return p.id === id;
    }) || {};
    storedProposal.settings = preserveSettings ? storedProposal.settings : {};
    proposal.settings = JSON.stringify(_objectSpread({
        value: cartValue * 100,
        clientName: name,
        expiryDate: date ? new Date(date).toISOString() : "",
        companyName: companyName,
        email: email || ((ref1 = context.state.user) === null || ref1 === void 0 ? void 0 : ref1.email),
        items: items || context.state.cart,
        options: options || {},
        issueDate: new Date().toISOString()
    }, storedProposal.settings, settings));
    return proposal;
};
